// extracted by mini-css-extract-plugin
module.exports = {"modalLoader":"ModalLoader_modalLoader__26I5P","overlay":"ModalLoader_overlay__3MMDe","loader":"ModalLoader_loader__xun4L"};